module.exports = __webpack_public_path__ + "img/portal-button.bea89d1f.jpg";